<template>
<div id="tag-form">
  <form
    :method="methodType"
    accept-charset="UTF-8"
    autocomplete="off"
    :action="actionUrl"
    id="userForm"
    v-on:submit.prevent="submit"
  >
    <div>
      <fieldset class="form-group">

        <legend v-if="tagId">Edit Tag #{{ tagId }}</legend>
        <legend v-else>Create Tag</legend>

        <div class="form-group">
          <label for="tag_name" class="control-label required">
            Name
          </label>

          <input type="text"
            name="tag[name]"
            class="form-control"
            id="tag_name"
            placeholder="Enter name"
            required="true"
            autofocus="true"
            v-model="name"
          >
        </div>

        <div class="form-group">
          <label for="tag_description" class="control-label">
            Description
          </label>

          <textarea type="description"
            name="tag[description]"
            class="form-control"
            id="tag_description"
            placeholder="Enter description"
            v-model="description"
          ></textarea>
        </div>

        <div class="form-group">
          <label for="tag_type" class="control-label">
            Tag Type
          </label>

          <select
            name="tag[type]"
            class="form-control"
            id="tag_type"
            v-model="tagType"
            :selected="isSelected(tagType)"
          >
            <option value="">
              Generic Tag
            </option>
            <option value="AffiliateTag">
              Affiliate - For Purchases
            </option>
          </select>
        </div>

        <div class="form-group">
          <input type="hidden" name="tag[visible]" value="false" />
          <input type="checkbox"
            name="tag[visible]"
            id="tag_visible"
            v-model="visible"
          />

          <label for="tag_visible" class="control-label">
            Visible to all users?
          </label>
        </div>

      </fieldset>
    </div>

    <button
      type="submit"
      class="btn btn-block btn-danger"
      v-if="id"
      v-on:click.prevent="deleteTag"
    >
      Delete Tag
      <tag-delete-spinner
        size="small"
        v-if="loading"
      ></tag-delete-spinner>
    </button>

    <button
      type="submit"
      class="btn btn-block btn-primary"
    >
      {{ this.id ? 'Edit' : 'Create' }} Tag

      <tag-submit-spinner
        size="small"
        v-if="loading"
      ></tag-submit-spinner>
    </button>
  </form>
</div>
</template>

<script>
import VueSpinner from 'vue-simple-spinner'

import FlashStore from '@/stores/FlashStore'
import TagStore from '@/stores/TagStore'

export default {
  data () {
    return TagStore.state
  },

  computed: {
    methodType () {
      return this.id ? 'PUT' : 'POST'
    },

    actionUrl () {
      return this.apiUrl('/tags/' + (this.id ? this.id : ''), true)
    }
  },

  components: {
    'tag-delete-spinner': VueSpinner,
    'tag-submit-spinner': VueSpinner
  },

  props: [ 'tagId' ],

  created () {
    this.loading = false
    this.$forceUpdate()

    if (this.tagId) {
      this.get()
    }
  },

  methods: {
    isSelected (tagType) {
      return tagType === this.tagType
    },

    get () {
      this.apiGet('/tags/' + this.tagId, TagStore, true)
    },

    deleteTag () {
      if (confirm('Are you sure you want to delete this tag? This cannot be undone.')) {
        this.loading = true

        this.$http.delete(
          this.apiUrl('/tags/' + this.tagId, true)
        ).then(() => {
          this.loading = false

          this.$router.push({
            'name': 'tags'
          })

          FlashStore.result('Tag deleted.')
        }, (resp) => {
          this.loading = false
          this.$parent.$parent.processErrors(resp)
        })
      }
    },

    submit (ev) {
      this.loading = true

      this.bindSubmit(ev).then((response) => {
        this.loading = false
        const tagId = response.body.data.id

        this.$router.push({
          name: 'tag',
          params: {
            tagId: tagId
          }
        })
      }, (resp) => {
        this.loading = false
        this.$parent.$parent.processErrors(resp)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TagForm.vue